
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import mqtt from "mqtt";
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  TextField,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import MapView from "./MapView";
import ErrorBoundary from "./ErrorBoundary";
//import axios from './AxiosInstance';
import { fetchWithAuth } from './fetchWithAuth';
//import Mqtt_user from "./Login"

// Status color based on device cloud timestamp
// const statusColor = (timestamp) => {
//   if (!timestamp) return "gray";
//   const ts = new Date(timestamp).getTime();
//   const now = Date.now();
//   const diffInMinutes = (now - ts) / (1000 * 60);
//   if (diffInMinutes <= 5) return "green"; // ✅ within 5 minutes
//   if (diffInMinutes <= 60 * 24) return "yellow"; // within 24 hours
//   if (diffInMinutes <= 60 * 48) return "red"; // within 48 hours
//   return "gray";
// };
const statusColor = (timestamp) => {
  if (!timestamp) return "gray";

  const tsDate = new Date(timestamp);
  const now = new Date();

  const diffInMinutes = (now.getTime() - tsDate.getTime()) / (1000 * 60);

  const isToday = tsDate.toDateString() === now.toDateString();

  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);
  const isYesterday = tsDate.toDateString() === yesterday.toDateString();

  if (diffInMinutes <= 5) return "green"; // within 5 minutes
  if (isToday) return "yellow"; // today but older than 5 minutes
  if (isYesterday) return "red"; // yesterday
  return "gray"; // older than yesterday
};



// Count devices by status
// const getDeviceStatusCounts = (devices) => {
//   const now = Date.now();
//   const all = devices.length;
//   let on = 0, onToday = 0, offToday = 0, offline = 0;

//   devices.forEach((device) => {
//     const ts = device.cloud_ts ? new Date(device.cloud_ts).getTime() : 0;
//     if (!ts) {
//       offline++;
//       return;
//     }

//     const diffMinutes = (now - ts) / (1000 * 60); // difference in minutes
//     const diffHours = diffMinutes / 60;

//     if (diffMinutes <= 5) {
//       on++;
//       onToday++;
//     } else if (diffHours <= 24) {
//       onToday++;
//     } else if (diffHours <= 48) {
//       offToday++;
//     } else {
//       offline++;
//     }
//   });

//   return { all, on, onToday, offToday, offline };
// };
const getDeviceStatusCounts = (devices) => {
  const now = new Date();
  const all = devices.length;
  let on = 0, onToday = 0, offToday = 0, offline = 0;

  const todayStr = now.toDateString();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const yesterdayStr = yesterday.toDateString();

  devices.forEach((device) => {
    if (!device.cloud_ts) {
      offline++;
      return;
    }

    const tsDate = new Date(device.cloud_ts);
    const diffMinutes = (now.getTime() - tsDate.getTime()) / (1000 * 60);

    if (diffMinutes <= 5) {
      on++;
      onToday++;
    } else if (tsDate.toDateString() === todayStr) {
      onToday++;
    } else if (tsDate.toDateString() === yesterdayStr) {
      offToday++;
    } else {
      offline++;
    }
  });

  return { all, on, onToday, offToday, offline };
};




const Dashboard2 = () => {
  const [devices, setDevices] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDevice, setSelectedDevice] = useState(null);
  const navigate = useNavigate();
  const clientRef = useRef(null);
  const currentUser = sessionStorage.getItem("currentUser");
  const token = sessionStorage.getItem(`token_${currentUser}`);
  let sessionExpiredHandled = false;
  // Auth check + fetch devices
  useEffect(() => {
    const currentUser = sessionStorage.getItem("currentUser");
    const token = sessionStorage.getItem(`token_${currentUser}`);
    // const mqtt_user = sessionStorage.getItem("mqttUser");
    // const password = sessionStorage.getItem("password");

    // console.log(mqtt_user);
    // console.log(password);
    if (!token) {
      navigate("/");
    } else {
      setIsAuthenticated(true);
    }
    fetchWithAuth(`/api/devices`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    
      //.then((res) => res.json())
      .then((data) => {
        console.log("Fetched Devices:", data);
        if (!Array.isArray(data)) {
          throw new Error(data.message || "Invalid response from server");
        }
        setDevices(data);
        
      })
      .catch((err) => {
        const msg = err?.message || err?.response?.data?.message;
      
        if ((msg === 'Token has expired' || msg === 'Invalid token') && sessionExpiredHandled === false) {
          sessionExpiredHandled=true;
          alert(' Session expired. Logging you out.');
      
          const currentUser = sessionStorage.getItem("currentUser");
          sessionStorage.removeItem(`token_${currentUser}`);
          sessionStorage.removeItem("currentUser");
      
          navigate("/");
        } else {
        //  alert(" Something went wrong.");
          console.error(err);
        }
      })
      .finally(() => setLoading(false));
      
        }, [navigate]);

  // MQTT connection once
  useEffect(() => {
    const mqtt_user = sessionStorage.getItem("mqttUser");
    const password = sessionStorage.getItem("password");
    console.log(mqtt_user);
    console.log(password);
    const options = {
      username: mqtt_user,
      password: password,
      clientId: mqtt_user,
      protocolVersion: 5,
      clean: true,
      rejectUnauthorized: false,
    };

    const client = mqtt.connect("wss://sandbox.atslrail.com/mqtt", options);

    client.on("connect", () => {
      console.log("✅ MQTT Connected");
      client.subscribe("dev/tel", (err) => {
        if (!err) console.log("📡 Subscribed to dev/tel");
      });
    });

    client.on("message", (topic, message) => {
      try {
        const payload = JSON.parse(message.toString());
        payload.timestamp = new Date(payload.ts * 1000).toISOString();
        console.log("📥 MQTT Payload:", payload);

        // ✅ UPDATED setDevices logic
        setDevices((prevDevices) => {
          const deviceIndex = prevDevices.findIndex(
            (d) => String(d.device_id) === String(payload.id)
          );

          if (deviceIndex !== -1) {
            const updatedDevices = [...prevDevices];
            updatedDevices[deviceIndex] = {
              ...updatedDevices[deviceIndex],
              lat: payload.lat,
              lng: payload.lng,
              cloud_ts: payload.timestamp,
              telemetry: payload,
              //lastMqttPayload: payload,
            };
            console.log(`✅ Updated device ${payload.id}`);
            return updatedDevices;
          } else {
            const newDevice = {
              device_id: payload.id,
              name: payload.name || `Device ${payload.id}`,
              lat: payload.lat,
              lng: payload.lng,
              cloud_ts: payload.timestamp,
              telemetry: payload,
              //lastMqttPayload: payload,
            };
            console.log(`➕ Added new device ${payload.id}`);
            return [...prevDevices, newDevice];
          }
        });

        // ✅ UPDATE selectedDevice if matching
        setSelectedDevice((prev) => {
          if (prev && String(prev.device_id) === String(payload.id)) {
            return {
              ...prev,
              lat: payload.lat,
              lng: payload.lng,
              telemetry: payload,
              updatedAt: Date.now(),
            };
          }
          return prev;
        });

      } catch (err) {
        console.error("❌ Failed to parse MQTT message", err);
      }
    });

    client.on("error", (err) => {
      console.error("❗ MQTT Error:", err);
    });

    clientRef.current = client;

    return () => {
      if (clientRef.current) {
        clientRef.current.end(true);
        console.log("🧹 Cleaned up MQTT client");
      }
    };
  }, []);

  const handleDeviceClick = async (device) => {
    try {
      console.log(device.device_id);
      const res = await fetchWithAuth(`/api/devices/${device.name}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      const result = await res;
      console.log("Selected Device Details (before adding id):", result);

      const updatedResult = { ...result, device_id: device.device_id };
      console.log("Selected Device Details (with id):", updatedResult);
      setSelectedDevice(updatedResult);
    } catch (error) {
      //console.error("Error fetching device details:", error);
      const msg = error.response?.data?.message;

  if ((msg === 'Token has expired' || msg === 'Invalid token') && sessionExpiredHandled ===false) {
     sessionExpiredHandled = true;
    alert('⏰ Session expired. Logging you out.');

    // 🔐 Clear token and user info
    const currentUser = sessionStorage.getItem("currentUser");
    sessionStorage.removeItem(`token_${currentUser}`);
    sessionStorage.removeItem("currentUser");

    // ⛔ Navigate to login
    navigate("/");
  } else {
   // alert(" Something went wrong.");
  }

    }
  };

  const filteredDevices = devices.filter((device) =>
    device.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const statusCounts = getDeviceStatusCounts(filteredDevices);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box display="flex" height="90vh">
      {/* Device List Panel */}
      <Paper elevation={3} sx={{ width: 300, p: 2, overflowY: "auto" }}>
        <Typography variant="h6">Devices</Typography>
        <TextField
          label="Search device"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ my: 2 }}
        />
        <List>
          {filteredDevices.map((device) => (
            <ListItem key={device.device_id || device.id} button onClick={() => handleDeviceClick(device)}>
              <ListItemIcon>
                <FiberManualRecordIcon sx={{ color: statusColor(device.cloud_ts) }} />
              </ListItemIcon>
              <ListItemText primary={device.name || device.device_id} />
            </ListItem>
          ))}
        </List>
      </Paper>

      {/* Main Map & Status Panel */}
      <Box flex={1}>
        {isAuthenticated ? (
          <ErrorBoundary>
            {/* Status Count Row */}
            <Box display="flex" alignItems="center" gap={2} p={1} sx={{ backgroundColor: "#fff" }}>
              <Typography color="primary"><b>●</b> All {statusCounts.all}</Typography>
              <Typography sx={{ color: "green" }}>● On {statusCounts.on}</Typography>
              <Typography sx={{ color: "orange" }}>● On Today {statusCounts.onToday}</Typography>
              <Typography sx={{ color: "red" }}>● off Today {statusCounts.offToday}</Typography>
              <Typography sx={{ color: "gray" }}>● Off Since 48hrs {statusCounts.offline}</Typography>
            </Box>

            <MapView selectedDevice={selectedDevice} filteredDevices={filteredDevices} />
          </ErrorBoundary>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Typography variant="body1">Unauthorized</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Dashboard2;
